import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const RightArrow = props => (
  <SvgIcon viewBox="0 0 14.817 28.05" {...props}>
    <path
      transform="translate(-112.556)"
      d="M127.144,13.466,113.912.234a.794.794,0,0,0-1.123,1.123l12.668,12.668L112.79,26.692a.8.8,0,0,0,.558,1.358.774.774,0,0,0,.558-.235l13.232-13.232A.789.789,0,0,0,127.144,13.466Z"
    />
  </SvgIcon>
);

export default RightArrow;
